import axios from 'axios';
import { API, ApiKey } from '../config';
import { TABLE_NUM_ITEMS } from '../constants';
const headerAPI = { ApiKey: `${ApiKey}`};

export const getUser = (id) => {
  // return axios.get(`${API}/api/users/${id}`, { headers: headerAPI });
  return axios.get(`${API}/api/users?offset=0&limit=${TABLE_NUM_ITEMS}&conditions=id=${id}`, { headers: headerAPI });
};
